<template>
  <ModalView v-model="show" v-bind="$attrs" title="Error" @ok="show = false">
    <div v-if="!!modelValue" class="w-100 p-4 text-center text-danger h5 mb-0">
      <p>We're sorry. An error occurred.</p>
      <p>{{ modelValue }}</p>
    </div>
  </ModalView>
</template>

<script>
import ModalView from "@/components/common/ModalView.vue";

export default {
  components: {ModalView},
  props: {
    modelValue: Error
  },
  emits: ['update:modelValue'],
  computed: {
    show: {
      get() {
        return Boolean(this.modelValue);
      },
      set(show) {
        if (!show) {
          this.$emit('update:modelValue', null);
        }
      }
    }
  }
}
</script>
